export default {
    title: `<i class="fa fa-lg fa-pencil-square"></i> 코드, 프로그래밍 언어 문법 강조, 표 그리기`,
    datas: [
        { type: "subtitle",
            content: `<i class="fa fa-asterisk"></i> 코드 강조 `
        },
        { type: "text",
            content: "문장 중간에 코드나 단축키 같은 것을 강조할때 `(백틱)기호를 감싸면 해당 부분을 강조할 수 있습니다. "
        },
        { type: "code", code: "plaintext", drag: true,
            result: "https://github.com/denlyou/sblabs_markdown_codelab_examples/blob/master/section05/exam02.md",
            content:
`- 프로그래밍을 처음 시작할 때는 \`print("Hello World");\`부터... 
- 입력 폼의 내용을 전체를 선택하는 단축키 \`Ctrl + a\`입니다.`
        },


        { type: "subtitle",
            content: `<i class="fa fa-asterisk"></i> 프로그래밍 언어 문법 강조`
        },
        { type: "text",
            content: "깃허브에서 가장 강력하고 많이 사용되는 문법입니다. 프로그램 소스 코드를 구문 강조를 할수 있습니다."
        },
        { type: "code2", code: "md", drag: true,
            content:
`\`\`\`[프로그래밍언어]
// 프로그램 소스코드 일부 또는 전체
\`\`\``
        },
        { type: "text",
            content: "간단한 c언어와 java언어로 예로 들자면 아래와 같이 작성합니다."
        },
        { type: "code", code: "plaintext", drag: true,
            result: "https://github.com/denlyou/sblabs_markdown_codelab_examples/blob/master/section05/exam03.md",
            content:
`\`\`\`c
#include<stdio.h>
int main(){
  printf("Hi C World");
}
\`\`\`

\`\`\`java
public class Main {
    public static void main(String[] args) {
        System.out.print("Hi Java World")
    }
}
\`\`\``
        },
        { type: "text",
            content: "Github에서는 다양한 언어의 문법을 강조할 수 있으며 정확한 목록은 다음을 참고해 주세요."
        },
        { type: "link",
            content: "Github에서 구문 강조를 지원하는 프로그래밍 언어 목록",
            url: "https://github.com/github/linguist/blob/master/lib/linguist/languages.yml"
        },
        { type: "link",
            content: "Github에서 구문 강조하는 프로그래밍 언어 규칙 Repo",
            url: "https://github.com/github/linguist/tree/master/samples"
        },


        { type: "subtitle",
            content: `<i class="fa fa-asterisk"></i> 표 그리기 `
        },
        { type: "text",
            content: "마크다운에서는 |(세로줄: <kbd>Shift+\\</kbd>)기호와 -(빼기)기호를 이용해 간단한 테이블을 만들 수 있습니다. "
        },
        { type: "code", code: "md", drag: true,
            result: "https://github.com/denlyou/sblabs_markdown_codelab_examples/blob/master/section05/exam04.md",
            content:
`| 제목1 | 제목2 | 제목3 |
| --- | --- | --- |
| 셀1-1 | 셀1-2 | 셀1-3 |
| 셀2-1 | 셀2-2 | 셀3-3 |`
        },
        { type: "text",
            content: "테이블의 두번째 줄에 :(콜론)기호를 사용하면 해당 세로줄의 셀들의 정렬을 설정할 수도 있습니다."
        },
        { type: "code", code: "plaintext", drag: true,
            result: "https://github.com/denlyou/sblabs_markdown_codelab_examples/blob/master/section05/exam05.md",
            content:
`| 가운데 정렬 | 오른쪽 정렬 | 왼쪽 정렬 |
| :---: | ---: | :--- |
| 철수 | 3,000 | 아메리카노 |
| 영희 | 4,500 | 카푸치노 |
| 승빈 | 5,200 | 고구마라떼 |`
        },
        { type: "text",
            content: "간단한 표를 만들기에는 좋으나 복잡한 규칙의 테이블을 만들기는 어렵습니다."
        },


        { type: "subtitle",
            content: `<i class="fa fa-check-square"></i> Check it!`
        },
        { type: "quiz",
            content: "[Quiz] 다음 기호 중 코드를 강조하는 문법에 사용하는 기호로 옳은?",
            questions: [
                "\" (큰따옴표)",
                "' (작은따옴표)",
                "` (백틱:역따옴표)", 
            ],
            answers: [2],
        },
        { type: "oxquiz",
            content: "마크다운 문법으로 프로그래밍 구문을 강조할 때 여러줄의 코드를 입력할 수 있다.",
            ans: true,
        },
        { type: "oxquiz",
            content: "마크다운 문법으로 표를 작성할 경우 셀의 세로 정렬을 설정할 수 있다.",
            ans: false,
        },


        { type: "next",
            content: "다음",
            url: "/sections/06"
        },
    ]
}